import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';

import {
  ArticleContent,
  ArticleMainScreen,
  CrumbsNav,
  PaginationArrow,
} from '../components/Pages/Article';

import { articleStatic } from '../db/articleStatic';

const articlePage = ({data, pageContext}) => {
  const dataArticle = data.strapiBlogArticles
  return (
    <Layout>
      <Seo title={'Article'} />
      <ArticleMainScreen 
        mainData={dataArticle.article} 
        category={dataArticle.category}
      />
      <ArticleContent 
        contentData={dataArticle.content_builder} 
      />
      <PaginationArrow pageContext={pageContext}/>
      <CrumbsNav crumbsData={articleStatic.crumbs_nav} crumbsCat={dataArticle.category} crumbsArticle={dataArticle} />
    </Layout>
  );
};

export default articlePage;

export const query = graphql`
  query Article($language: String!, $id: String!) {
    strapiBlogArticles(id: { eq: $id }) {
      seo_title_ua
      seo_title_ru
      seo_description_ua
      seo_description_ru
      title_ua
      title_ru
      slug
      category {
        title_ua
        title_ru
        slug
      }
      article {
        title_ua
        title_ru
        time_ua
        time_ru
        date
      }
      content_builder
  }

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
